module.exports = __webpack_public_path__ + "img/vue2-renfort_bleu.19efb3db.png";